/**
 * Middleware utilitaire pour générer dynamiquement l'URL BFF selon le host courant.
 */
/**
 * Retourne l'URL BFF adaptée à l'extension du domaine courant.
 * @param baseUrl L'URL BFF de base (ex: https://bff.homeexchange.com)
 * @param host Optionnel, pour override (utile pour tests)
 */
export function getDynamicBffUrl(baseUrl, host) {
    // Utilise le host courant si non fourni
    var currentHost = host || window.location.host;
    // Récupère l'extension du domaine (ex: .fr, .it, .com)
    var extMatch = currentHost.match(/\.(com|fr|it)$/);
    var ext = extMatch ? extMatch[0] : '.com';
    // Remplace l'extension dans l'URL BFF de base
    return baseUrl.replace(/\.(com|fr|it)([\/:]|$)/, ext + '$2');
}
